// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

// Additional Libraries
import { setupMenuTrigger, setupFooterToggle } from './modules/menu';
import { setupCookieNoticePopup } from './modules/cookie-notice';
import { rerunGravityFormsScripts, rerunTypeFormEmbed } from './modules/forms';

// Swup setup
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import GlobalMeasurements from './modules/global-measurements';

const options = {
	linkSelector: `a[href^="${window.location.origin}"]:not([data-no-swup]):not([target="_blank"]), a[href^="/"]:not([data-no-swup]):not([target="_blank"]), a[href^="#"]:not([data-no-swup]):not([target="_blank"])`,
	plugins: [
		new SwupBodyClassPlugin(),
		new SwupScrollPlugin({
			doScrollingRightAway: true,
			animateScroll: false,
		}),
	],
	animateHistoryBrowsing: true,
	containers: [
		'#body-wrapper',
	],
	skipPopStateHandling: function(event) {
		if (event.state && event.state.source == 'swup') {
			return false;
		}
		return false;
	},
};

export const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	setupMenuTrigger();
	setupCookieNoticePopup();
	setupFooterToggle();
	GlobalMeasurements.start();
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => {
	rerunGravityFormsScripts();
	rerunTypeFormEmbed();
	routes.loadEvents()
});

swup.on('willReplaceContent', () => {
	routes.unloadEvents()
});



// WEBPACK FOOTER //
// ./scripts/main.js